import { store } from '../redux/storeConfig/store';
import { applicationActions } from '../new.redux/actions';

import API from './API';
import { history } from '../history';

const APIRedux = (apiOptions = {}, toggleLoading = true) => {
  const silent = apiOptions._silent === true;
  if (silent) {
    const { _silent, ...rest } = apiOptions;
    apiOptions = rest;
  }
  const shouldToggleLoading = toggleLoading && !silent;
  const apiInstance = API(apiOptions);
  apiInstance.interceptors.request.use(
    (instanceConfig) => {
      if (shouldToggleLoading) {
        store.dispatch(applicationActions.toggleLoading());
      }
      return instanceConfig;
    },

    (error) => {
      if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
      store.dispatch(
        applicationActions.toggleDialog({
          type: 'error',
          title: 'Ops!',
          message: error.message,
        })
      );

      return Promise.reject(error);
    }
  );

  apiInstance.interceptors.response.use(
    (response) => {
      if (shouldToggleLoading) {
        if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
      }
      // On Success return only the response data. If there's no data on responde, return all response
      return response.data || response;
    },

    (error) => {
      const { response } = error;
      let { code, message } = error;
      if (response) {
        code = response.status;
        message = response.data.errors
          ? response.data.errors[Object.keys(response.data.errors)[0]][0]
          : message;
      }
      const _error = { code, message };

      if (_error.message === 'Network Error') {
        _error.message = 'Verifique sua conexão com a internet';
      }

      if (_error.code === 401) {
        if (response.config.url === 'auth/login') {
          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          store.dispatch(
            applicationActions.toggleDialog({
              type: 'error',
              title: 'Ops!',
              message: response?.data?.error,
            })
          );
        } else if (response?.data?.message === 'Unauthenticated.') {
          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          store.dispatch({ type: 'SET_USER_AUTHENTICATED', payload: false });
          store.dispatch({ type: 'LOGOUT' });
          history.push('/login');
        } else {
          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          history.push('/login');
        }
      } else if (_error.code === 403) {
        if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
        // history.push('/welcome');
        // store.dispatch(
        //   applicationActions.toggleDialog({
        //     type: 'error',
        //     title: 'Ops!',
        //     message: 'Acesso não autorizado',
        //   })
        // );
        // history.push('/admin')
      } else if (_error.code === 422) {
        const requestedUrl = error.config?.url;
        const isImportExcelError =
          requestedUrl.includes('/import') &&
          !requestedUrl.includes('ofx/import');
        
        // Não mostrar dialog genérico para erro duplicated_period - deixar componente tratar
        const isDuplicatedPeriodError = response.data?.error === 'duplicated_period';
        
        // Tratar erros de período fechado com warning
        const periodClosedErrors = [
          'period_closed',
          'period_closed_batch',
          'period_closed_sale',
          'period_closed_sales_batch',
        ];
        const isPeriodClosedError = periodClosedErrors.includes(response.data?.error);
        
        // Tratar erro de cobrança associada no Asaas com warning
        const isChargeInAsaasError = response.data?.error === 'has_charge_in_asaas';
        const isPaidChargeInAsaasError = response.data?.error === 'has_paid_charge_in_asaas';
        const isHasChargeError = response.data?.error === 'has_charge';
        const isHasIuliBankError = response.data?.error === 'has_iuli_bank';
        
        if (!isDuplicatedPeriodError && !isPeriodClosedError && !isChargeInAsaasError && !isPaidChargeInAsaasError && !isHasChargeError && !isHasIuliBankError) {
          let messageError = 'Ops! Falha na validação dos dados.';
          if (isImportExcelError) {
            messageError =
              'Ops! Falha na validação dos dados. Nenhum dado foi importado.';
          } else {
            const firstErrorMessage =
              response.data.errors?.[
                Object.keys(response.data?.errors || {})?.[0]
              ]?.[0];
            messageError =
              response.data.error || firstErrorMessage || response.data.message;
          }

          // Dados obrigatórios da empresa / configuração NF: mostrar como aviso (triângulo laranja + "Atenção!")
          const isCompanyDataRequiredError = messageError && (
            typeof messageError === 'string' &&
            (messageError.includes('dados obrigatórios') || messageError.includes('preenchidos corretamente'))
          );

          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          store.dispatch(
            applicationActions.toggleDialog({
              type: isCompanyDataRequiredError ? 'warning' : 'error',
              title: isCompanyDataRequiredError ? 'Atenção!' : 'Ops!',
              message: messageError,
              requestedUrl,
              ...(isImportExcelError && {
                allErrors: Object.keys(response.data?.errors || {}).map(
                  (key) => ({
                    row: key.split('.')[1],
                    message: response.data.errors[key][0],
                  })
                ),
              }),
            })
          );
        } else if (isPeriodClosedError) {
          // Mostrar warning com triângulo amarelo para erros de período fechado
          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          store.dispatch(
            applicationActions.toggleDialog({
              type: 'warning',
              title: 'Atenção',
              message: response.data?.message || 'O período está fechado e esta operação não pode ser realizada.',
              confirmBtnText: 'Entendi',
            })
          );
        } else if (isChargeInAsaasError || isPaidChargeInAsaasError) {
          // Mostrar warning para erro de cobrança associada no Asaas (paga ou não paga)
          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          store.dispatch(
            applicationActions.toggleDialog({
              type: 'warning',
              title: 'Atenção',
              message: response.data?.message || (isPaidChargeInAsaasError 
                ? 'Esta venda possui uma cobrança associada que já foi paga na integração com o Asaas (Conta Iuli). Por isso, a venda não pode ser excluída.'
                : 'Esta venda possui uma cobrança associada criada na integração com o Asaas (Conta Iuli). Por isso, a venda não pode ser excluída.'),
              confirmBtnText: 'Entendi',
            })
          );
        } else if (isHasChargeError || isHasIuliBankError) {
          // Mostrar warning para erro de cobrança associada (geral ou conta Iuli)
          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          store.dispatch(
            applicationActions.toggleDialog({
              type: 'warning',
              title: 'Atenção',
              message: response.data?.message || 'Vendas associadas a Cobranças não podem ser excluídas.\n\nVocê pode Cancelar cobranças em aberto antes de tentar excluir as vendas associadas.\n\nCobranças já pagas não podem ser excluídas.',
              confirmBtnText: 'Entendi',
            })
          );
        } else {
          // Para duplicated_period, apenas esconder loading e deixar componente tratar
          if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
          // Rejeitar o erro original para manter a estrutura (error.response.data)
          return Promise.reject(error);
        }
      } else if (_error.code === 500) {
        if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
        store.dispatch(
          applicationActions.toggleDialog({
            type: 'error',
            title: 'Ops!',
            message: 'Tente novamente mais tarde.',
            details: 'Ocorreu um erro inesperado.',
          })
        );
      } else if (_error.code === 404) {
        if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
        const errorMessage = response?.data?.message || response?.data?.error || _error.message;
        
        // Check if it's a "No query results for model" error (deleted resource)
        const isModelNotFoundError = errorMessage && errorMessage.includes('No query results for model');
        
        if (isModelNotFoundError) {
          store.dispatch(
            applicationActions.toggleDialog({
              type: 'warning',
              title: 'Transação não encontrada',
              message: 'Não encontramos uma transação com este ID.\nÉ provável que esta transação tenha sido excluída.',
            })
          );
        } else {
          store.dispatch(
            applicationActions.toggleDialog({
              type: 'warning',
              title: 'Recurso não encontrado',
              message: errorMessage || 'O recurso solicitado não foi encontrado.',
            })
          );
        }
      } else {
        if (shouldToggleLoading) store.dispatch(applicationActions.hideLoading());
        const errorMessage = response?.data?.message || response?.data?.error || _error.message;
        
        // Check if it's an invoice limit error - show as warning instead of error
        const isInvoiceLimitError = errorMessage && (
          errorMessage.includes('Limite de emissão de notas atingido') ||
          errorMessage.includes('limite de notas')
        );

        // Check if it's a reconciliation error - show as warning instead of error
        const isReconciliationError = errorMessage && (
          errorMessage.includes('já estão Conciliadas') ||
          errorMessage.includes('desconciliar')
        );

        // Check if it's a sync sales limit error - show as warning instead of error
        const isSyncSalesLimitError = errorMessage && (
          errorMessage.includes('número máximo de vendas foi excedido') ||
          errorMessage.includes('Máximo de vendas permitido')
        );

        // Check if it's certificate expired (Enotas CER0003) - show as alert/warning
        const isCertificateExpiredError =
          response?.data?.error === 'certificate_expired' ||
          (errorMessage && errorMessage.includes('Certificado digital expirado'));

        // Dados obrigatórios da empresa / configuração NF: triângulo laranja + "Atenção!"
        const isCompanyDataRequiredError = errorMessage && typeof errorMessage === 'string' &&
          (errorMessage.includes('dados obrigatórios') || errorMessage.includes('preenchidos corretamente'));

        const isWarning = isInvoiceLimitError || isReconciliationError || isSyncSalesLimitError || isCertificateExpiredError || isCompanyDataRequiredError;

        // Determine the appropriate title based on error type
        let dialogTitle = 'Ops!';
        if (isInvoiceLimitError) {
          dialogTitle = 'Limite de Notas Fiscais';
        } else if (isSyncSalesLimitError) {
          dialogTitle = 'Limite de Sincronização';
        } else if (isCertificateExpiredError) {
          dialogTitle = 'Alerta';
        } else if (isCompanyDataRequiredError) {
          dialogTitle = 'Atenção!';
        }

        const displayMessage = isCertificateExpiredError
          ? 'Certificado digital expirado'
          : errorMessage;

        store.dispatch(
          applicationActions.toggleDialog({
            type: isWarning ? 'warning' : 'error',
            title: dialogTitle,
            message: displayMessage,
          })
        );
      }
      return Promise.reject(error);
    }
  );

  return apiInstance;
};

export default APIRedux;
